// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TagTwoToneSvg from "@fishx/icons-svg/es/asn/TagTwoTone";
import FishxIcon from '../components/FishxIcon';

var TagTwoTone = function TagTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TagTwoToneSvg
  }));
};

TagTwoTone.displayName = 'TagTwoTone';
export default React.forwardRef(TagTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TagTwoTone.js
// module id = 4240
// module chunks = 0